import { Input } from "antd";
import { Loading } from "./Loading/Loading";
import { FiCheck } from "@react-icons/all-files/fi/FiCheck";
import { FiXCircle } from "@react-icons/all-files/fi/FiXCircle";
import React from "react";

const okCancelIconCommonStyles: React.CSSProperties = {
    position: "relative",
    top: "3px",
    cursor: "pointer",
};

interface EditInput {
  name: string;
  isLoading: boolean;
  onCancel: () => void;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
}

const EditInput = ({
    name,
    onCancel,
    isLoading,
    onChange,
    onSubmit,
}: EditInput) => {
    const isNameValid = name.length > 1;
    return (
        <Input
            value={name}
            onChange={onChange}
            maxLength={250}
            disabled={isLoading}
            style={{
                width: "100%",
                fontSize: 13,
                height: 24,
            }}
            addonAfter={
                isLoading ? (
                    <Loading
                        style={{
                            paddingTop: 5,
                        }}
                    />
                ) : (
                    <>
                        <FiCheck
                            size="24px"
                            color={isNameValid ? "#1CE180" : "gray"}
                            onClick={isNameValid ? onSubmit : null}
                            style={{
                                ...okCancelIconCommonStyles,
                                marginRight: 6,
                                cursor: isNameValid ? "pointer" : "not-allowed",
                            }}
                        />
                        <FiXCircle
                            size="24px"
                            color="red"
                            style={{
                                ...okCancelIconCommonStyles,
                            }}
                            onClick={onCancel}
                        />
                    </>
                )
            }
        />
    );
};

export default EditInput;
